module.exports = __webpack_public_path__ + "media/assets/rightBtnNavBar-5846d25e70351ac205f0dc997ddedbcd.png";